import React from 'react'
import { Dropdown, DropdownButton } from 'react-bootstrap'
import { availableCurrenciesSubset, getCurrencyNameBySymbol } from '../../constants/currency'

const CurrencyDropdown = ({ selectedCurrency, onCurrencySelected, showSymbol = true }) => {
  return null // Hide for now

  return (
    <DropdownButton
      className="text-start text-dark-blue"
      title={`${showSymbol ? `${selectedCurrency} - ` : ''}${getCurrencyNameBySymbol(selectedCurrency)}`}
      size="sm"
      variant="outline-secondary"
    >
      {availableCurrenciesSubset.map((currency) => (
        <Dropdown.Item
          key={currency.symbol}
          eventKey={currency.symbol}
          onClick={() => onCurrencySelected(currency.symbol)}
        >
          {currency.symbol} - {currency.name}
        </Dropdown.Item>
      ))}
    </DropdownButton>
  )
}

export default CurrencyDropdown
